import {isWsLogin$, wsLogin$, wsLogout$} from '@/user/auth-ws';
import {toWsMsg$} from '@/ws';

const auctionParams = ['service.phemex_auction'];

export class WsSubscribe {
  public isOpen: boolean = false;
  public isConnect: boolean = false;

  constructor() {
    wsLogin$.subscribe(() => this._subscribe(true));
    wsLogout$.subscribe(() => this._unsubscribe());
  }

  destroy() {
    this._unsubscribe();
  }

  subscribe() {
    this.isOpen = true;
    if (isWsLogin$.getValue()) {
      this._subscribe();
    }
  }

  unsubscribe() {
    this.isOpen = false;
    this._subscribe();
  }

  _subscribe(isForceConnect = false) {
    if ((!isForceConnect && this.isConnect) || !this.isOpen) {
      return;
    }
    this.isConnect = true;
    toWsMsg$.next({method: 'service.subscribe', params: auctionParams});
  }

  _unsubscribe() {
    if (!this.isConnect) {
      return;
    }
    this.isConnect = false;
    toWsMsg$.next({method: 'service.unsubscribe', params: auctionParams});
  }
}
